import React from 'react';
import { getIntl } from '../../../../../../../utils/intl';
import { AnimateLoadedContent } from '../../../../../../v2BaseComponents/Loader';
import { SideDrawerButtonContainer } from '../../../../../../v2BaseComponents/Form/SideDrawerFormContainer';
import CopyOrganizationCareTeamMembersToClients, {
    useCopyOrganizationCareTeamMemberToClientsState,
} from '../../../../../../shared/ClientRecord/CopyOrganizationCareTeamMembersToClients';

const intl = getIntl('copy-organization-care-team-member', {
    cancel: 'Cancel',
    share: 'Share',
});

export type CopyOrganizationCareTeamMemberSideDrawerContentOwnProps = {
    destinationMedicalProfileIds: string[];
    onClose: (force: boolean) => void;
};

export type CopyOrganizationCareTeamMemberSideDrawerContentProps =
    CopyOrganizationCareTeamMemberSideDrawerContentOwnProps;

const CopyOrganizationCareTeamMemberSideDrawerContent: React.FC<
    CopyOrganizationCareTeamMemberSideDrawerContentProps
> = (props) => {
    const {
        isInitializing,
        isSubmitting,
        selectedCareTeamMemberIds,
        selectedCareTeamMembers,
        careTeamSelectOptions,
        onSubmit,
        canSubmit,
        onSelectedCareTeamMemberId,
    } = useCopyOrganizationCareTeamMemberToClientsState({
        onClose: () => props.onClose(false),
        destinationMedicalProfileIds: props.destinationMedicalProfileIds,
    });

    const isLoading = isInitializing || isSubmitting;
    return (
        <AnimateLoadedContent isLoading={isLoading}>
            {() => (
                <SideDrawerButtonContainer
                    disableScroll
                    buttons={[
                        {
                            title: intl('cancel'),
                            variant: 'secondary',
                            onPress: () => props.onClose(true),
                            isDisabled: isLoading,
                            testID: 'form-submit-cancel',
                            icon: 'XCircle',
                        },
                        {
                            title: `${intl('share')}${
                                selectedCareTeamMemberIds.length ? ` (${selectedCareTeamMemberIds.length})` : ''
                            }`,
                            variant: 'primary',
                            onPress: onSubmit,
                            isDisabled: !canSubmit || isLoading,
                            testID: 'form-submit-button',
                            icon: 'Share2',
                        },
                    ]}
                    contentContainerStyle={{ padding: 0 }}
                >
                    <CopyOrganizationCareTeamMembersToClients
                        careTeamSelectOptions={careTeamSelectOptions}
                        selectedCareTeamMemberIds={selectedCareTeamMemberIds}
                        selectedCareTeamMembers={selectedCareTeamMembers}
                        onSelectedCareTeamMemberId={onSelectedCareTeamMemberId}
                        destinationMedicalProfileIds={props.destinationMedicalProfileIds}
                        isDisabled={isSubmitting}
                        flatCards
                    />
                </SideDrawerButtonContainer>
            )}
        </AnimateLoadedContent>
    );
};

export default React.memo(CopyOrganizationCareTeamMemberSideDrawerContent);
